/* Helpers for talking to the <tag-input> web component from outside Vue.
 *
 * <tag-input> is registered via register-tag.js with no shadow DOM and no
 * attribute observation, so once mounted its `model-value` prop is fixed.
 * The component exposes event-based "back doors" on its parent node for
 * external mutations; these helpers wrap them. */

export const setTagInputSelection = (tagInput, names) => {
  tagInput.dispatchEvent(new CustomEvent("external-update:selected-tags", { detail: names }));
};

export const addTagInputSelection = (tagInput, tag) => {
  tagInput.dispatchEvent(new CustomEvent("external-add:model-value", { detail: tag }));
};
